import { render, staticRenderFns } from "./MemberDetail.vue?vue&type=template&id=495bc8c6"
import script from "./MemberDetail.vue?vue&type=script&lang=js"
export * from "./MemberDetail.vue?vue&type=script&lang=js"
import style0 from "./MemberDetail.vue?vue&type=style&index=0&id=495bc8c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports